<template>
  <div class="animated fadeIn month">
    <filters :scope="filtersScope">
    </filters>
    <BuyoutTabs></BuyoutTabs>
      <div style="overflow:hidden; width:100%" >
        <div :key="indexYear" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}" id="swipe1" style="display:flex;flex-wrap: nowrap;" v-for="(indexMonth,indexYear) in totalAllColumns" v-hammer:pan="onSwipe">
          <div :key="`${indexYear}_${indexCourier}`" style="flex: 0 0 880px;" v-for="(rowsMonth,indexCourier,index) in indexMonth">
            <div class=" statistic-table" style="margin-bottom:0; " >
              <div class="card-header">
                {{month[indexCourier - 1]}} {{indexYear}} г.<br/>
              </div>
              <TemporaryTable
                  :className="`${[indexYear]}-${month[indexCourier - 1]}`"
                  :headColumns="headColumnsTotal"
                  :rows="[]"
                  :footColumns="totalAllColumns[indexYear][indexCourier][0]"
                  :totalColumnsDd="totalCourier[indexYear][indexCourier]"
                  :title="`${$t('statistic.in_total')}`"
              ></TemporaryTable>
            </div>
          </div>
        </div>
        <div :key="indexYear" :style="{ 'transform': 'translate3d(' + x + 'px, 0px, 0px)'}" id="swipe" v-for="(rowsCourier,indexYear) in rows" v-hammer:pan="onSwipe">
          <div :key="`${indexYear}_${indexCourier}`" style="display:flex;flex-wrap: nowrap;" v-for="(rowsMonth,indexCourier,index) in rowsCourier">
            <div :key="`${indexYear}_${indexCourier}_${indexMonth}`" style="flex: 0 0 880px;"  v-for="(rowsData, indexMonth) in rowsMonth">
              <div v-if="rowsData.length !== 0">
                <div class=" statistic-table" style="margin-bottom:0; " >
                  <StatisticTable :className="`${[indexYear]}-${[indexMonth]}`"
                                  :footColumns="footColumns[indexYear][indexCourier][indexMonth][0]"
                                  :headColumns="headColumns"
                                  :rows="rowsData"
                                  :title="`${Helper.getOfferTitle(Storage.offers, indexCourier)}`"
                  >
                  </StatisticTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import Filters from '../../../components/Filters.vue'
import API from '../../../api/API'
import Storage from '../../../api/Storage'
import Helper from '../../../api/Helper'
import TypeColor from '../../../assets/TypeColor'
import { map, isNaN, values, groupBy } from 'lodash'
import StatisticTable from '../../../components/StatisticTable.vue'
import BuyoutTabs from './BuyoutTabs'
import getSymbolFromCurrency from 'currency-symbol-map'
import TemporaryTable from '../../../components/TemporaryTable'

export default {
  name: 'Flypost',
  components: {
    TemporaryTable,
    BuyoutTabs,
    Filters,
    StatisticTable
  },
  data () {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        courierFilter: true
      },
      Storage: Storage,
      branchStatistics: false,
      TypeColor: TypeColor,
      Helper: Helper,
      loading: false,
      country: null,
      headColumnsTotal: [
        {label: this.$root.$t('statistic.courier'), field: 'courier'},
        {label: this.$root.$t('statistic.shipped'), field: 'shipped'},
        {label: this.$root.$t('statistic.delivered'), field: 'delivered'},
        {label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2},
        {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
        {label: this.$root.$t('statistic.buyout'), field: 'buyout'},
        {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2}
      ],
      headColumns: [
        {label: this.$root.$t('statistic.day'), field: 'week'},
        {label: this.$root.$t('statistic.shipped'), field: 'shipped'},
        {label: this.$root.$t('statistic.delivered'), field: 'delivered'},
        {label: this.$root.$t('statistic.transit'), field: 'transit', colspan: 2},
        {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
        {label: this.$root.$t('statistic.buyout'), field: 'buyout'},
        {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2}
      ],
      month: [
        'Январь',
        'Февраль',
        'Март',
        'Апрель',
        'Май',
        'Июнь',
        'Июль',
        'Август',
        'Сентябрь',
        'Октябрь',
        'Ноябрь',
        'Декабрь'
      ],
      rows: [],
      rowsTotal: [],
      footColumns: {},
      summary: {},
      totalAllColumns: {},
      offers: [],
      totalCourier: {},
      x: 0
    }
  },
  mounted () {
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  methods: {
    onSwipe (e) {
      const offset = document.getElementById('swipe').offsetWidth
      const scroll = document.getElementById('swipe').scrollWidth
      const offset1 = document.getElementById('swipe1').offsetWidth
      const scroll1 = document.getElementById('swipe1').scrollWidth
      const width = scroll - offset
      const width1 = scroll1 - offset1
      if (width > 0) {
        if (e.deltaX >= 0) {
          this.x += e.distance / 10
        } else {
          this.x -= e.distance / 10
        }
        if (this.x > 0) {
          this.x = 0
        }
        if (Math.abs(this.x) > width) {
          this.x = -width
        }

        if (width1 > 0) {
          if (e.deltaX >= 0) {
            this.x += e.distance / 10
          } else {
            this.x -= e.distance / 10
          }
          if (this.x > 0) {
            this.x = 0
          }
          if (Math.abs(this.x) > width1) {
            this.x = -width1
          }
        }
      }
    },
    calculateRows () {
      this.rows = []
      this.footColumns = {}
      this.$root.$emit('data_loading')
      this.loading = true
      API.getBuyoutStatisticMonth().then(response => {
        this.rows = this.statisticData(response.body)
        this.loading = false
        this.$root.$emit('data_loaded')
      }).catch(response => {
        this.loading = false
        this.$notify({
          type: 'danger',
          title: this.$root.$t('verbs.error'),
          text: !response.body.message ? response.body : response.body.message,
          animationType: 'velocity'
        })
      })
    },
    statisticData (rows) {
      let newRows = {}
      let totalDeliveredCount1 = {}
      let years = []
      this.footColumns = {}
      this.totalAllColumns = {}

      let oldArrCurrency = []
      let newArrCurrency = []
      let filterCurrency = []

      let totalShipped = 0
      let totalReturn = 0
      let totalPaid = 0
      let totalDelivered = 0
      let totalTransit = 0
      let sumTransit = 0
      let sumAverageBill = 0.0
      let sumAverageBillLocal = 0.0

      let allTotalShipped = 0
      let allTotalReturn = 0
      let allTotalPaid = 0
      let allTotalDelivered = 0
      let allTotalTransit = 0
      let allTotalSumTransit = 0
      let allTotalSumAverageBill = 0.0
      let allTotalSumAverageBillLocal = 0.0

      this.offers = Storage.offers.slice(0)
      this.couriers = Storage.couriers.slice(0)

      let arrayMonth = []

      map(rows, (rowsMonth, indexYear) => {
        if (!newRows[indexYear]) {
          newRows[indexYear] = {}
          this.footColumns[indexYear] = {}
          this.totalAllColumns[indexYear] = {}
        }
        years.push(indexYear)
        totalDeliveredCount1 = { [indexYear]: {}, rowsMonth, years }
        map(rowsMonth, (rowsCourier, indexMonth) => {
          arrayMonth.push(indexMonth)
          totalDeliveredCount1[indexYear] = {
            [indexMonth]: {},
            ...totalDeliveredCount1[indexYear]
          }
          for (let courierIndex in rowsCourier) {
            rowsCourier[courierIndex].map(courierKey => {
              totalDeliveredCount1[indexYear][indexMonth] = {
                [courierKey.courier_id]: {
                  courier_name: Helper.getCourierTitle(this.couriers, courierKey.courier_id),
                  shipped: 0,
                  delivered: 0,
                  transit: 0,
                  transitPercent: 0.0,
                  return: 0,
                  returnPercent: 0.0,
                  buyout: 0,
                  totalLocal: 0.0,
                  approved: 0,
                  totalBillLocal: 0.0,
                  totalBill: 0
                },
                ...totalDeliveredCount1[indexYear][indexMonth]
              }
            })
          }
          if (!this.totalAllColumns[indexYear][indexMonth]) {
            this.totalAllColumns[indexYear][indexMonth] = []
            allTotalShipped = 0
            allTotalReturn = 0
            allTotalPaid = 0
            allTotalDelivered = 0
            allTotalTransit = 0
            allTotalSumAverageBill = 0.0
            allTotalSumAverageBillLocal = 0.0
          }
          map(rowsCourier, (rowsData, indexCourier) => {
            if (!newRows[indexYear][indexCourier]) {
              newRows[indexYear][indexCourier] = {}
              this.footColumns[indexYear][indexCourier] = {}
            }
            if (!newRows[indexYear][indexCourier][indexMonth]) {
              newRows[indexYear][indexCourier][indexMonth] = []
              this.footColumns[indexYear][indexCourier][indexMonth] = []
            }
            map(arrayMonth, perMonth => {
              if (!newRows[indexYear][indexCourier][perMonth]) {
                newRows[indexYear][indexCourier][perMonth] = []
                this.footColumns[indexYear][indexCourier][perMonth] = []
              }
            })
            totalShipped = 0
            totalDelivered = 0
            totalReturn = 0
            totalPaid = 0
            totalTransit = 0
            sumTransit = 0
            sumAverageBill = 0.0
            sumAverageBillLocal = 0.0
            map(rowsData, (rowsOfferTotal, i) => {
              oldArrCurrency.push(rowsOfferTotal.local_currency.split(','))
              oldArrCurrency.forEach(array => {
                array.forEach(item => {
                  newArrCurrency.push(item)
                })
              })
              filterCurrency = newArrCurrency.filter((item, index) => {
                return newArrCurrency.indexOf(item) === index
              })
              totalShipped += parseInt(rowsOfferTotal.shipped)
              totalDelivered += parseInt(rowsOfferTotal.delivered)
              totalReturn += parseInt(rowsOfferTotal.return)
              totalPaid += parseInt(rowsOfferTotal.paid)
              totalTransit += parseInt(rowsOfferTotal.transit)
              if (rowsOfferTotal.approved > 0) {
                sumTransit += rowsOfferTotal.approved
                sumAverageBill += parseFloat(rowsOfferTotal.average_bill_usd) * rowsOfferTotal.approved
                sumAverageBillLocal += parseFloat(rowsOfferTotal.average_bill_local) * rowsOfferTotal.approved
                this.localCurrencySymbol = getSymbolFromCurrency(rowsOfferTotal.local_currency)
              }
            })
            allTotalShipped += parseInt(totalShipped)
            allTotalDelivered += parseInt(totalDelivered)
            allTotalReturn += parseInt(totalReturn)
            allTotalPaid += parseInt(totalPaid)
            allTotalTransit += parseInt(totalTransit)
            allTotalSumTransit += parseFloat(sumTransit)
            allTotalSumAverageBill += parseFloat(sumAverageBill)
            allTotalSumAverageBillLocal += parseFloat(sumAverageBillLocal)
            map(rowsData, (rowsOffer) => {
              newRows[indexYear][indexCourier][indexMonth].push({
                courier: {
                  value: Helper.getCourierTitle(this.couriers, rowsOffer.courier_id),
                  indexCourier: rowsOffer.courier_id,
                  indexMonth: indexMonth
                },
                shipped: {
                  value: rowsOffer.shipped,
                  bg: true
                },
                delivered: {
                  value: rowsOffer.delivered,
                  bg: true
                },
                transit: {
                  value: rowsOffer.shipped - rowsOffer.delivered - rowsOffer.return
                },
                transitPercents: {
                  value: Helper.percents(rowsOffer.shipped, rowsOffer.shipped - rowsOffer.delivered - rowsOffer.return)
                },
                return: {
                  value: rowsOffer.return
                },
                returnPercents: {
                  value: Helper.percents(rowsOffer.shipped, rowsOffer.return)
                },
                buyout: {
                  value: Helper.percents(rowsOffer.shipped, rowsOffer.delivered)
                },
                averageBill: {
                  value: '$ ' + rowsOffer.average_bill_usd.toFixed(2)
                },
                averageBillLocal: {
                  value: rowsOffer.local_currency.split(',').length === 1 && rowsOffer.average_bill_local > 0 ? `${rowsOffer.average_bill_local.toFixed(0)} ${getSymbolFromCurrency(rowsOffer.local_currency)}` : '-'
                }
              })
            })
            this.footColumns[indexYear][indexCourier][indexMonth].push({
              label: {
                value: this.$root.$t('statistic.in_total')
              },
              shipped: {
                value: totalShipped
              },
              delivered: {
                value: totalDelivered
              },
              transit: {
                value: totalTransit
              },
              transitPercents: {
                value: Helper.percents(totalShipped, totalTransit)
              },
              return: {
                value: totalReturn
              },
              returnPercents: {
                value: Helper.percents(totalShipped, totalReturn)
              },
              buyout: {
                value: Helper.percents(totalShipped, totalDelivered)
              },
              averageBill: {
                value: Helper.averageBillDayCount(sumAverageBill, sumTransit)
              },
              averageBillLocal: {
                value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumAverageBillLocal, sumTransit, this.localCurrencySymbol) : '-'
              }
            })
          })
          this.totalAllColumns[indexYear][indexMonth].push({
            label: {
              value: this.$root.$t('statistic.in_total'),
              width: '14%'
            },
            shipped: {
              value: allTotalShipped,
              width: '12%'
            },
            delivered: {
              value: allTotalDelivered,
              width: '15%'
            },
            transit: {
              value: allTotalTransit,
              width: '13%'
            },
            transitPercents: {
              value: Helper.percents(allTotalShipped, allTotalTransit),
              width: '5%'
            },
            return: {
              value: allTotalReturn,
              width: '7%'
            },
            returnPercents: {
              value: Helper.percents(allTotalShipped, allTotalReturn),
              bg: true,
              width: '10%'
            },
            buyout: {
              value: Helper.percents(allTotalShipped, allTotalDelivered),
              bg: true,
              width: '10%'
            },
            averageBill: {
              value: Helper.averageBillDayCount(allTotalSumAverageBill, allTotalSumTransit),
              width: '13%'
            },
            averageBillLocal: {
              value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(allTotalSumAverageBillLocal, allTotalSumTransit, this.localCurrencySymbol) : '-',
              width: '13%'
            }
          })
        })
        if (totalDeliveredCount1.years) {
          totalDeliveredCount1.years.map(year => {
            for (let key in totalDeliveredCount1.rowsMonth) {
              let month = key
              let company = totalDeliveredCount1.rowsMonth[key]
              for (let key in company) {
                company[key].map(courierId => {
                  this.localCurrencySymbol = getSymbolFromCurrency(courierId.local_currency)

                  totalDeliveredCount1[year][month][courierId.courier_id].shipped += parseInt(courierId.shipped)
                  totalDeliveredCount1[year][month][courierId.courier_id].delivered += parseInt(courierId.delivered)
                  totalDeliveredCount1[year][month][courierId.courier_id].transit += parseInt(courierId.transit)
                  totalDeliveredCount1[year][month][courierId.courier_id].transitPercent = Helper.percents(totalDeliveredCount1[year][month][courierId.courier_id].shipped, totalDeliveredCount1[year][month][courierId.courier_id].transit)
                  totalDeliveredCount1[year][month][courierId.courier_id].return += parseInt(courierId.return)
                  totalDeliveredCount1[year][month][courierId.courier_id].returnPercent = Helper.percents(totalDeliveredCount1[year][month][courierId.courier_id].shipped, totalDeliveredCount1[year][month][courierId.courier_id].return)
                  totalDeliveredCount1[year][month][courierId.courier_id].buyout = Helper.percents(totalDeliveredCount1[year][month][courierId.courier_id].shipped, totalDeliveredCount1[year][month][courierId.courier_id].delivered)

                  totalDeliveredCount1[year][month][courierId.courier_id].totalBill += parseFloat(courierId.total_bill_usd)
                  totalDeliveredCount1[year][month][courierId.courier_id].totalBillLocal += parseFloat(courierId.total_bill_local)
                  totalDeliveredCount1[year][month][courierId.courier_id].approved += parseInt(courierId.approved)
                  totalDeliveredCount1[year][month][courierId.courier_id].totalLocal = totalDeliveredCount1[year][month][courierId.courier_id].totalBillLocal
                  totalDeliveredCount1[year][month][courierId.courier_id].totalLocal = filterCurrency.length === 1 && totalDeliveredCount1[year][month][courierId.courier_id].approved > 0
                      ? Helper.newLocalAverageBill(totalDeliveredCount1[year][month][courierId.courier_id].totalBillLocal, totalDeliveredCount1[year][month][courierId.courier_id].approved, this.localCurrencySymbol) : '-'
                })
              }
            }
          })
        }
      })
      this.totalCourier = totalDeliveredCount1
      return newRows
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Month.vue?3d781e41